// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  partyId: __t.u64().name("party_id"),
  genre: __t.string(),
  rule: __t.string(),
  weightRule: __t.string().name("weight_rule"),
  pieces: __t.array(__t.string()),
  clueTotal: __t.u8().name("clue_total"),
  mapClues: __t.u8().name("map_clues"),
  rewardXp: __t.u32().name("reward_xp"),
  debtXp: __t.u32().name("debt_xp"),
  par: __t.u16(),
  forced: __t.bool(),
  place: __t.string(),
  scene: __t.string(),
  freeHints: __t.u8().name("free_hints"),
});
